import React, { useEffect, useState } from 'react'
import { apiPost, apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import ErrorMessage from '../../components/ErrorMessage'
import useToastContext from 'hooks/useToastContext'
import { useTranslation } from 'react-i18next'
import { HiOutlineInformationCircle } from 'react-icons/hi2'
import { validationRules } from 'utils/constants'

const BackgroundModal = ({ onHide, getAllBackgrounds, editData, setPage }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const [color, setColor] = useState(Object.keys(editData).length !== 0 && editData !== undefined ? editData?.colorCode : '')
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({ mode: 'onBlur', shouldFocusError: true, defaultValues: {} })


  useEffect(() => {
    if (Object.keys(editData).length !== 0 && editData !== undefined) {
      setValue('colorCode', editData.colorCode ?? '')
    }
  }, [editData])

  const handleSubmitForm = async (data) => {
    if (Object.keys(editData).length === 0) {
      try {
        const res = await apiPost(apiPath.backgroundList, { colorCode: data?.colorCode })
        if (res.data.success === true) {
          setPage(1)
          getAllBackgrounds()
          onHide()
          notification.success(res.data.message)
        } else {
          notification.error(res?.data.message)
        }
      } catch (err) {
        console.log('err:', err)
      }
    } else {
      try {
        const res = await apiPut(apiPath.backgroundList + '/' + editData._id, {colorCode: data?.colorCode})
        if (res.data.success === true) {
          getAllBackgrounds()
          onHide()
          notification.success(res.data.message)
        } else {
          notification.error(res?.data.message)
        }
      } catch (err) {
        console.log('err:', err)
      }
    }
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <form className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[462px]' onSubmit={handleSubmit(handleSubmitForm)}>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{editData && Object.keys(editData)?.length ? t('O_COLOR_CODE_EDIT') : t('O_COLOR_CODE_ADD')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => onHide()}
                >
                  <span
                    className=' text-[#B8BBBF]  text-4xl '
                    title={t('O_CLOSE')}
                  >
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>

                <div className='grid grid-cols-1'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <div className='flex'>
                      <input
                        type='text'
                        name='colorCode'
                        id='colorCode'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        maxLength={7}
                        {...register('colorCode', {
                          required: t('VALIDATION_COLOR_CODE_REQUIRED'),
                          pattern: {
                            value: validationRules.colorCode,
                            message: t("INVALID_COLOR_CODE")
                          },
                          validate: value => {
                            const val = value.trim()
                            return val.length < 4 
                            ? t('VALIDATION_COLOR_CODE_MIN_LENGTH')
                            : true
                          }
                        })}
                        onChange={(event) => {
                          var value = event.target.value;
                          value = value.trimStart()
                          setValue('colorCode', value, { shouldValidate: true })
                          setColor(value)
                        }}
                      />
                      <label
                        htmlFor='colorCode'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_COLOR_CODE')}<span className='text-red-500'>*</span>

                      </label>
                      <div className={`h-12 w-12 rounded-lg ml-2 mt-1 border`} style={{backgroundColor:color}}></div>   
                      </div>
                      <ErrorMessage message={errors?.colorCode?.message} />
                    </div>
                    <div className='pt-4 flex items-center text-lg text-LightBlue'><HiOutlineInformationCircle/><span className='text-xs ml-1'>Use hash codes only.</span></div>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='bg-LightBlue text-white active:bg-emerald-600 font-normal uppercase text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                  type='submit'
                >
                  {editData && Object.keys(editData)?.length ? t('O_EDIT') : t('O_ADD')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default BackgroundModal